import { TreeOurNodeObj } from "./tree-our-node-obj";
import { OurNode } from "@src/cloud-connect/poc/our-node";
import { getNodeManager } from "@src/cloud-connect/dependency-injection-container/get-node-manager";

export const useTreeOurNodeInitialHook = (): TreeOurNodeObj => {
  const handleCheckBoxClick = (node: OurNode) => {
    getNodeManager().getInitialCheckBoxClickHandler().toggleSelected(node);
  };

  return {
    handleCheckBoxClick: handleCheckBoxClick,
  };
};
